var _path, _path2, _path3, _g, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgHistory = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 510 512"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 380",
  d: "M390 0H165a45 45 0 00-45 45v422a45 45 0 0045 45h300a45 45 0 0045-45V120z",
  fill: "#e4f2f9"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 381",
  d: "M390 0h-75v512h150a45 45 0 0045-45V120z",
  fill: "#cdebfc"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 382",
  d: "M390 0v105a15 15 0 0015 15h105z",
  fill: "#bfe1fd"
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 70",
  fill: "#5f5f82"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 383",
  d: "M425 302H205a15 15 0 010-30h220a15 15 0 010 30z"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 384",
  d: "M425 212H205a15 15 0 010-30h220a15 15 0 010 30z"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 385",
  d: "M425 392H205a15 15 0 010-30h220a15 15 0 010 30z"
}))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 386",
  d: "M440 287a15 15 0 00-15-15H315v30h110a15 15 0 0015-15z",
  fill: "#3c3c55"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 387",
  d: "M440 197a15 15 0 00-15-15H315v30h110a15 15 0 0015-15z",
  fill: "#3c3c55"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 388",
  d: "M425 392a15 15 0 000-30H315v30z",
  fill: "#3c3c55"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 389",
  d: "M135 512C60.561 512 0 451.439 0 377s60.561-135 135-135 135 60.561 135 135-60.561 135-135 135z",
  fill: "#ed6c7b"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 390",
  d: "M135 242v270c74.439 0 135-60.561 135-135s-60.561-135-135-135z",
  fill: "#d65b72"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 391",
  d: "M135 272a105 105 0 10105 105 105.119 105.119 0 00-105-105z",
  fill: "#e4f2f9"
})), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 392",
  d: "M135 272v210a105 105 0 000-210z",
  fill: "#cdebfc"
})), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 393",
  d: "M175 362h-25v-45a15 15 0 00-30 0v60a15 15 0 0015 15h40a15 15 0 000-30z",
  fill: "#5f5f82"
})), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 394",
  d: "M175 362h-25v-45a15 15 0 00-15-15v90h40a15 15 0 000-30z",
  fill: "#3c3c55"
})));
export default SvgHistory;